import { X } from "lucide-react"
import { TOP_BAR_CELL } from "@/components/layout/topBarCell"
import type { Market } from "@/lib/useMarket"
import MarketSwitcher from "./MarketSwitcher"

interface Props {
  market: Market | null
  markets: Market[]
  onMarketChange: (market: Market) => void
  onClose: () => void
}

// The only part of the panel that stays put while it scrolls: a navy strip as
// tall as the top bar, carrying it on, with the market dropdown and the close
// button.
export default function PanelStrip({ market, markets, onMarketChange, onClose }: Props) {
  return (
    <div className="flex h-11 shrink-0 items-stretch bg-top-bar text-top-bar-foreground">
      <MarketSwitcher market={market} markets={markets} onChange={onMarketChange} />
      <button type="button" onClick={onClose} aria-label="Close" className={`${TOP_BAR_CELL} ml-auto`}>
        <X size={16} />
      </button>
    </div>
  )
}
